<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      :nudge-width="200"
      offset-x
    >
      <template v-slot:activator="{ on }">
        <v-btn
          class="btn-settings"
          color="gray"
          dark
          fab
          top
          right
          fixed
          v-on="on"
        >
          <v-icon>mdi-cog-outline</v-icon>
        </v-btn>
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <v-layout
              justify-left
              style="text-transform: normal;"
            >
              <v-icon>mdi-account</v-icon><span style="margin-left:15px">{{ userName }}</span>
            </v-layout>
          </v-list-item>
          <v-divider />
          <!--v-list-item>
            <workspaces-menu />
          </v-list-item-->
          <v-divider />
          <v-list-item>
            <v-layout
              justify-center
              style="text-transform: uppercase;"
            >
              {{ $t('common.language')}}
            </v-layout>
          </v-list-item>
          <v-list-item>
            <v-layout
              justify-center
              style="text-transform: uppercase;"
            >
              <v-btn class="mr-4" color="primary" text @click="handleChangeLocale('es')">ESPAÑOL</v-btn><v-btn class="mr-4" color="primary" text @click="handleChangeLocale('en')">ENGLISH</v-btn>              
            </v-layout>
          </v-list-item>
          <v-divider />
          <v-list-item>
            <create-ticket 
              :onClose="() => { menu = false }"
            />
          </v-list-item>
          <v-divider />
          <v-list-item>
            <change-password
              :onChangeMessage="handleChangeMessage"
            />
          </v-list-item>
          <v-divider />
          <v-list-item>
            <v-btn
              block
              color="secondary"
              dark
              @click="handleLogout"
            >
              {{ $t('dashboard.logout') }}
            </v-btn>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
    <v-snackbar
      top
      right
      v-model="snackbar"
      :timeout="timeout"
      :color="messageColor"
    >
      {{ message }}
      <v-btn
        color="black"
        text
        @click="snackbar = false"
      >
        {{ $t('common.close') }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import i18n from '@/plugins/i18n'
  import utils from '@/services/utils'
  import api from '@/services/api'
  import CreateTicket from './CreateTicket'
  import ChangePassword from './ChangePassword'
  //import WorkspaceMenu from './WorkspaceMenu'
  export default {
    components: {
      CreateTicket,
      ChangePassword
    },
    data: () => ({
      fav: true,
      menu: false,
      hints: true,
      snackbar: false,
      message: false,
      messageColor: 'success',
      timeout: 3000,
    }),
    computed: {
      userName () {
        return this.$store.state.app.userName
      },
    },
    mounted () {
      this.handleCheckEnterprise()
    },
    methods: {
      handleCheckEnterprise () {
        /*
        if (utils.getEnterpriseID()) return
        api.getAll(`users/${utils.getUserID()}/auth-enterprises/${utils.getEnterpiseID()}`, true, 1, 100000, '')
          .then(response => {
            const enterprises = response ? response.data : []
            utils.setActiveEnterprise(this, enterprises.map(item => item.ID).shift())
            alert('aaa')
          })
        */
      },
      handleLogout () {
        this.$router.push('/login')
      },
      handleChangeLocale (locale) {
        i18n.locale = locale
        this.$store.state.app.locale = locale
      },
      handleChangeMessage (msg, color) {
        this.message = msg
        this.messageColor = color
        this.snackbar = true
      }
    }
  }
</script>

<style>
  .btn-settings {
    opacity: 0.4;
    margin-top: 0px;
    margin-right: -15px;
    border-radius: 15px 0 0 15px;
  }
</style>
